<template>
  <ColumnWithHelp
    :title="$t('ADVERTISEMENT.BID.MATCH_TYPE')"
    :resizable="false"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_MATCH_TYPE_CONTENT')"
    :min-width="120"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot="{ row: { matchingType, id } }">
      <MatchTypeColumnContent
        :id="id"
        :matching-type="matchingType"
        :is-hovered="id === currentHoveredRowId"
        :read-only="readOnly"
      />
    </template>
  </ColumnWithHelp>
</template>

<script>
import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

import MatchTypeColumnContent from './MatchTypeColumnContent';

export default {
  name: 'MatchTypeColumn',
  components: {
    ColumnWithHelp,
    MatchTypeColumnContent,
  },
  inheritAttrs: false,
  props: {
    currentHoveredRowId: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
